export default "__VITE_ASSET__BLbp0mZ7__"